(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["9mm-v7-athlete-feature"] && !Shopify.designMode) return;
  try {
    (() => {
    const initializeAthlete = root => {
      if (!root || root.dataset.v7AthleteReady) return;
      root.dataset.v7AthleteReady = 'true';
      const reduced = window.matchMedia('(prefers-reduced-motion: reduce)');
      if (!('IntersectionObserver' in window) || reduced.matches || navigator.connection?.saveData) return;
      root.classList.add('is-motion');
      const observer = new IntersectionObserver(entries => entries.forEach(entry => {
        if (entry.isIntersecting) { entry.target.classList.add('is-visible'); observer.unobserve(entry.target); }
      }), { threshold: .08 });
      root.querySelectorAll('[data-v7-athlete-reveal]').forEach(element => observer.observe(element));
      const disableMotion = () => { if (reduced.matches) { root.classList.remove('is-motion'); observer.disconnect(); } };
      reduced.addEventListener('change', disableMotion);
      root.v7AthleteCleanup = () => { observer.disconnect(); reduced.removeEventListener('change', disableMotion); };
    };
    document.querySelectorAll('[data-v7-athlete]').forEach(initializeAthlete);
    document.addEventListener('shopify:section:load', event => { if (event.target.matches('[data-v7-athlete]')) initializeAthlete(event.target); event.target.querySelectorAll('[data-v7-athlete]').forEach(initializeAthlete); });
    document.addEventListener('shopify:section:unload', event => event.target.querySelectorAll('[data-v7-athlete]').forEach(root => root.v7AthleteCleanup?.()));
  })();
  } catch(e) { console.error(e); }
})();

})();
